module.exports = __webpack_public_path__ + "img/Weapon_27.926b6ee2.png";